export default __webpack_public_path__ + "static/media/erica.02371951.svg";